import React, {useState} from 'react';
import {Flex, Title, Icon, PriorityIcon} from '@priority-software/priority-style-react';
import debounce from 'lodash.debounce';
import {DropdownMenu} from './DropdownMenu';
import texts from '../texts';
import {MAX_LOAD} from '../consts';
import styles from '../styles/WidgetHeader.module.scss';
import {Tooltip} from '../../../components/Common/Tooltip/index';
import {getTopDialogZindex} from '../../../_shared/GWTBridge/invoke/priModalDlg';
import {Form} from '../../../stores/Form/Form';
import {isRTL} from '../../../Localization';

export const WidgetHeader = ({
    form,
    taskCount,
    deleteWidget,
    openToDoListScreen,
    setIsSettingsPanelOpen
}: {
    form: Form;
    taskCount: number;
    deleteWidget: () => void;
    openToDoListScreen: () => void;
    setIsSettingsPanelOpen: (boolean) => void;
}) => {
    const [isOpen, setIsOpen] = useState(false);

    const getCounterValue = () => {
        if (taskCount > MAX_LOAD) {
            if (isRTL()) {
                return '+' + MAX_LOAD;
            } else {
                return MAX_LOAD + '+';
            }
        }
        return taskCount;
    };

    return (
        <Flex justifyContent="space-between" alignItems="center">
            <Flex componentClasses={styles.widgetTitle} justifyContent="flex-start">
                <Title skin="h4" textColor="primary-700" text={form.title} />
                <Title skin="h4" textColor="secondary-400" text={texts.assigned_to_me} />
                <Title
                    skin="h4"
                    componentClasses={styles.taskCount}
                    textColor="secondary-500"
                    text={`(${getCounterValue()})`}
                />
            </Flex>
            <Flex justifyContent="flex-end" componentClasses={styles.widgetMenuWrapper}>
                <Tooltip
                    tooltip={texts.expand_tooltip}
                    position="top center"
                    zIndex={getTopDialogZindex()}
                >
                    <Icon
                        icon={PriorityIcon.externalLink}
                        iconColor="primary-700"
                        onClick={debounce(openToDoListScreen, 150)}
                        componentClasses={styles.headerIcon}
                    />
                </Tooltip>
                <DropdownMenu
                    open={isOpen}
                    deleteWidget={deleteWidget}
                    setOpen={setIsOpen}
                    setIsSettingsPanelOpen={setIsSettingsPanelOpen}
                />
            </Flex>
        </Flex>
    );
};
